import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ContactForm } from '@/features/directory/components/contact-form'
import { useCreateContact } from '@/features/directory/mutations'

export const Route = createFileRoute('/_authed/directory/new')({
  component: () => {
    const navigate = useNavigate()
    const createContact = useCreateContact()
    return (
      <ContactForm
        submitting={createContact.isPending}
        onSubmit={async (input) => {
          await createContact.mutateAsync(input)
          void navigate({ to: '/directory' })
        }}
      />
    )
  },
})
